(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arrow-down-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const OFFSET = 80; // adjust this if you want a different offset

  document.querySelectorAll('.arrow-down-nav a').forEach(link => {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');

      // only handle in-page links (that start with "#")
      if (targetId && targetId.startsWith('#')) {
        e.preventDefault();
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - OFFSET;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce2-banner-slick"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    $('.right-content').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: false,
      variableWidth: false,
      prevArrow:
        "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='52' viewBox='0 0 52 52' fill='none'><path d='M0 10C0 4.47715 4.47715 0 10 0L42 0C47.5228 0 52 4.47715 52 10L52 42C52 47.5228 47.5228 52 42 52L10 52C4.47715 52 0 47.5228 0 42L0 10Z' fill='#124143' fill-opacity='0.25'/><path d='M18 26L34 26M18 26L24 20M18 26L24 32' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      nextArrow:
        "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='52' viewBox='0 0 52 52' fill='none'><path d='M0 10C0 4.47715 4.47715 0 10 0L42 0C47.5228 0 52 4.47715 52 10L52 42C52 47.5228 47.5228 52 42 52L10 52C4.47715 52 0 47.5228 0 42L0 10Z' fill='#124143' fill-opacity='0.25'/><path d='M34 26H18M34 26L28 32M34 26L28 20' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: false,
            variableWidth: false,
          },
        },
      ],
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ce2-banner"] && !Shopify.designMode) return;
  try {
    
const bannerAssets = document.querySelector('.ce2-banner__assets');
const scrollLeftButton = document.querySelector('.scroll-arrow--left');
const scrollRightButton = document.querySelector('.scroll-arrow--right');

function scrollRight() {
    const maxScroll = bannerAssets.scrollWidth - bannerAssets.clientWidth;
    const newPosition = Math.min(bannerAssets.scrollLeft + 200, maxScroll);
    
    bannerAssets.scrollTo({
        left: newPosition,
        behavior: 'smooth'
    });
}

function scrollLeft() {
    const newPosition = Math.max(bannerAssets.scrollLeft - 200, 0);
    
    bannerAssets.scrollTo({
        left: newPosition,
        behavior: 'smooth'
    });
}

// Event listeners
scrollLeftButton.addEventListener('click', scrollLeft);
scrollRightButton.addEventListener('click', scrollRight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comp-lp-blocks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const OFFSET = 120; // adjust this if you want a different offset

  document.querySelectorAll('.links--wrapper a').forEach(link => {
    link.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');

      // only handle in-page links (that start with "#")
      if (targetId && targetId.startsWith('#')) {
        e.preventDefault();
        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - OFFSET;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comp-reviews-slider-v2"] && !Shopify.designMode) return;
  try {
     
// ========================
// Clean up unwanted elements
// ========================
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.homepage-reviews-stats').forEach(el => el.remove());
});

// ========================
// Helper: find related element (search up the DOM and down)
// ========================
function findRelated(el, selector) {
  let node = el;
  for (let i = 0; i < 6 && node; i++) {
    const found = node.querySelector(selector);
    if (found) return found;
    node = node.parentElement;
  }

  // fallback: try searching from the element's parent chain
  node = el.parentElement;
  for (let i = 0; i < 6 && node; i++) {
    const found = node.querySelector(selector);
    if (found) return found;
    node = node.parentElement;
  }

  // last resort: global selector
  return document.querySelector(selector);
}

// ========================
// Robust video play/pause handling
// ========================
function initializeVideoHandlers() {
  const videos = Array.from(document.querySelectorAll(".hcp-card-video-slidev2"));
  if (!videos.length) return;

  videos.forEach((video) => {
    // Prevent double initialization
    if (video.dataset.hcpInit === "1") return;
    video.dataset.hcpInit = "1";

    const playButton = findRelated(video, ".play-button-slidev2");
    const thumbnail = findRelated(video, ".video-thumbnail-slidev2");

    // Per-video state
    video._lastToggle = 0;                  // time of last toggle (ms)
    video._ignoreClickUntil = 0;            // suppress next clicks until this time (ms)

    const TOGGLE_MIN_INTERVAL = 350;        // ignore toggles faster than this
    const SUPPRESS_AFTER_BUTTON_MS = 700;   // suppress subsequent video click after button press

    // Helper: should we ignore clicks (suppression)
    function shouldIgnoreClick() {
      return video._ignoreClickUntil && Date.now() < video._ignoreClickUntil;
    }

    // Pause all other videos and restore their UI
    function pauseAllOthers() {
      const all = document.querySelectorAll(".hcp-card-video-slidev2");
      all.forEach((other) => {
        if (other === video) return;
        try {
          if (!other.paused) other.pause();
        } catch (e) {}
        const otherPB = findRelated(other, ".play-button-slidev2");
        const otherThumb = findRelated(other, ".video-thumbnail-slidev2");
        otherPB?.classList.remove("hidden");
        otherThumb?.classList.remove("hidden");
        // briefly suppress their clicks to avoid bounce
        other._ignoreClickUntil = Date.now() + 300;
        other.pause();
        other.currentTime = 0;  // optional: reset
        other.removeAttribute('src'); // unload
        other.load(); 
      });
    }

    // Toggle play/pause (returns a Promise to await video.play rejection if any)
    async function togglePlay() {
      const now = Date.now();
      if (now - video._lastToggle < TOGGLE_MIN_INTERVAL) return; // prevent rapid double toggles
      video._lastToggle = now;

      pauseAllOthers();

      if (video.paused) {
        try {
          // Attempt to play. This returns a promise in modern browsers.
          const p = video.play();
          if (p && typeof p.then === "function") {
            await p;
          }
          // On success, hide play UI
          playButton?.classList.add("hidden");
          thumbnail?.classList.add("hidden");
        } catch (err) {
          // Play failed (e.g., autoplay restrictions). Ensure play button remains visible.
          playButton?.classList.remove("hidden");
          thumbnail?.classList.remove("hidden");
          console.warn("Video play rejected:", err);
        }
      } else {
        try {
          video.pause();
        } catch (e) {}
        playButton?.classList.remove("hidden");
        thumbnail?.classList.remove("hidden");
      }
    }

    // Handler when the play button is used (pointer / touch / click)
    function onPlayButtonActivate(e) {
      // prevent synthesised click bubbling to the video and prevent default where possible
      if (e) {
        try { if (e.cancelable) e.preventDefault(); } catch (err) {}
        e.stopPropagation();
      }
      // Suppress the next video click which mobile often fires after touch
      video._ignoreClickUntil = Date.now() + SUPPRESS_AFTER_BUTTON_MS;
      togglePlay();
    }

    // Handler when the video itself is clicked
    function onVideoClick(e) {
      // If suppressed (recently activated via button), ignore this click
      if (shouldIgnoreClick()) {
        try { if (e?.cancelable) e.preventDefault(); } catch (err) {}
        e.stopPropagation();
        return;
      }
      togglePlay();
    }

    // Use pointer events first (modern), but attach fallbacks so code works across devices/browsers.
    if (playButton) {
      // Avoid duplicate listeners by setting a flag on the button
      if (playButton.dataset.hcpBtnInit !== "1") {
        playButton.dataset.hcpBtnInit = "1";
        // pointerup is good (handles mouse/touch/stylus). Passive:false so preventDefault works on touch.
        try {
          playButton.addEventListener("pointerup", onPlayButtonActivate, { passive: false });
        } catch (err) {
          // some older browsers ignore options — fallback to plain addEventListener
          playButton.addEventListener("pointerup", onPlayButtonActivate);
        }
        // Additional fallbacks
        playButton.addEventListener("touchend", onPlayButtonActivate, { passive: false });
        playButton.addEventListener("click", onPlayButtonActivate);
      }
    }

    // Attach video click handler (only once)
    if (!video.dataset.hcpVideoClickInit) {
      video.dataset.hcpVideoClickInit = "1";
      video.addEventListener("click", onVideoClick);
      // when video ends, restore UI
      video.addEventListener("ended", () => {
        playButton?.classList.remove("hidden");
        thumbnail?.classList.remove("hidden");
      });
    }
  });
}

function initializeSwipers() {
  const containers = document.querySelectorAll(".review-swiper-container");

  if (containers.length === 0) {
    // nothing to do now
    return;
  }

  containers.forEach((container) => {
    // If Swiper already attached via instance property, skip
    if (container.swiper) return;

    const isFour = container.id.includes("four");

    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      simulateTouch: true,
      allowTouchMove: true,
      cssMode: true,
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: false,
          pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
          }
        },
        1080: {
          slidesPerView: "auto",
          spaceBetween: isFour ? 20 : 24,
          navigation: {
            nextEl: container.querySelector(".swiper-button-next-hcp-arrow"),
            prevEl: container.querySelector(".swiper-button-prev-hcp-arrow"),
          },
          pagination: false
        },
         1501: {
          slidesPerView: 4,
          spaceBetween: isFour ? 20 : 24,
          navigation: {
            nextEl: container.querySelector(".swiper-button-next-hcp-arrow"),
            prevEl: container.querySelector(".swiper-button-prev-hcp-arrow"),
          },
          pagination:false
        },
      }
    });
  });
}

// ========================
// Debounce helper
// ========================
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// ========================
// Initialize everything
// ========================
function initializeAll() {
  initializeVideoHandlers();
  initializeSwipers();
}

// DOM ready init (small delay to let dynamic sections render)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(initializeAll, 100));
} else {
  setTimeout(initializeAll, 100);
}

// Reinitialize when DOM changes (Shopify dynamic sections)
const debouncedInitialize = debounce(initializeAll, 250);
const observer = new MutationObserver(function(mutations) {
  for (const mutation of mutations) {
    if (mutation.addedNodes && mutation.addedNodes.length) {
      debouncedInitialize();
      break;
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });

// Reinitialize swipers on resize
window.addEventListener('resize', debounce(initializeSwipers, 150));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comp-reviews-slider-v3"] && !Shopify.designMode) return;
  try {
     
// ========================
// Clean up unwanted elements
// ========================
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.homepage-reviews-stats').forEach(el => el.remove());
});

// ========================
// Helper: find related element (search up the DOM and down)
// ========================
function findRelated(el, selector) {
  let node = el;
  for (let i = 0; i < 6 && node; i++) {
    const found = node.querySelector(selector);
    if (found) return found;
    node = node.parentElement;
  }

  // fallback: try searching from the element's parent chain
  node = el.parentElement;
  for (let i = 0; i < 6 && node; i++) {
    const found = node.querySelector(selector);
    if (found) return found;
    node = node.parentElement;
  }

  // last resort: global selector
  return document.querySelector(selector);
}

// ========================
// Robust video play/pause handling
// ========================
function initializeVideoHandlers() {
  const videos = Array.from(document.querySelectorAll(".hcp-card-video-slidev2"));
  if (!videos.length) return;

  videos.forEach((video) => {
    // Prevent double initialization
    if (video.dataset.hcpInit === "1") return;
    video.dataset.hcpInit = "1";

    const playButton = findRelated(video, ".play-button-slidev2");
    const thumbnail = findRelated(video, ".video-thumbnail-slidev2");

    // Per-video state
    video._lastToggle = 0;                  // time of last toggle (ms)
    video._ignoreClickUntil = 0;            // suppress next clicks until this time (ms)

    const TOGGLE_MIN_INTERVAL = 350;        // ignore toggles faster than this
    const SUPPRESS_AFTER_BUTTON_MS = 700;   // suppress subsequent video click after button press

    // Helper: should we ignore clicks (suppression)
    function shouldIgnoreClick() {
      return video._ignoreClickUntil && Date.now() < video._ignoreClickUntil;
    }

    // Pause all other videos and restore their UI
    function pauseAllOthers() {
      const all = document.querySelectorAll(".hcp-card-video-slidev2");
      all.forEach((other) => {
        if (other === video) return;
        try {
          if (!other.paused) other.pause();
        } catch (e) {}
        const otherPB = findRelated(other, ".play-button-slidev2");
        const otherThumb = findRelated(other, ".video-thumbnail-slidev2");
        otherPB?.classList.remove("hidden");
        otherThumb?.classList.remove("hidden");
        // briefly suppress their clicks to avoid bounce
        other._ignoreClickUntil = Date.now() + 300;
        other.pause();
        other.currentTime = 0;  // optional: reset
        other.removeAttribute('src'); // unload
        other.load(); 
      });
    }

    // Toggle play/pause (returns a Promise to await video.play rejection if any)
    async function togglePlay() {
      const now = Date.now();
      if (now - video._lastToggle < TOGGLE_MIN_INTERVAL) return; // prevent rapid double toggles
      video._lastToggle = now;

      pauseAllOthers();

      if (video.paused) {
        try {
          // Attempt to play. This returns a promise in modern browsers.
          const p = video.play();
          if (p && typeof p.then === "function") {
            await p;
          }
          // On success, hide play UI
          playButton?.classList.add("hidden");
          thumbnail?.classList.add("hidden");
        } catch (err) {
          // Play failed (e.g., autoplay restrictions). Ensure play button remains visible.
          playButton?.classList.remove("hidden");
          thumbnail?.classList.remove("hidden");
          console.warn("Video play rejected:", err);
        }
      } else {
        try {
          video.pause();
        } catch (e) {}
        playButton?.classList.remove("hidden");
        thumbnail?.classList.remove("hidden");
      }
    }

    // Handler when the play button is used (pointer / touch / click)
    function onPlayButtonActivate(e) {
      // prevent synthesised click bubbling to the video and prevent default where possible
      if (e) {
        try { if (e.cancelable) e.preventDefault(); } catch (err) {}
        e.stopPropagation();
      }
      // Suppress the next video click which mobile often fires after touch
      video._ignoreClickUntil = Date.now() + SUPPRESS_AFTER_BUTTON_MS;
      togglePlay();
    }

    // Handler when the video itself is clicked
    function onVideoClick(e) {
      // If suppressed (recently activated via button), ignore this click
      if (shouldIgnoreClick()) {
        try { if (e?.cancelable) e.preventDefault(); } catch (err) {}
        e.stopPropagation();
        return;
      }
      togglePlay();
    }

    // Use pointer events first (modern), but attach fallbacks so code works across devices/browsers.
    if (playButton) {
      // Avoid duplicate listeners by setting a flag on the button
      if (playButton.dataset.hcpBtnInit !== "1") {
        playButton.dataset.hcpBtnInit = "1";
        // pointerup is good (handles mouse/touch/stylus). Passive:false so preventDefault works on touch.
        try {
          playButton.addEventListener("pointerup", onPlayButtonActivate, { passive: false });
        } catch (err) {
          // some older browsers ignore options — fallback to plain addEventListener
          playButton.addEventListener("pointerup", onPlayButtonActivate);
        }
        // Additional fallbacks
        playButton.addEventListener("touchend", onPlayButtonActivate, { passive: false });
        playButton.addEventListener("click", onPlayButtonActivate);
      }
    }

    // Attach video click handler (only once)
    if (!video.dataset.hcpVideoClickInit) {
      video.dataset.hcpVideoClickInit = "1";
      video.addEventListener("click", onVideoClick);
      // when video ends, restore UI
      video.addEventListener("ended", () => {
        playButton?.classList.remove("hidden");
        thumbnail?.classList.remove("hidden");
      });
    }
  });
}

function initializeSwipers() {
  const containers = document.querySelectorAll(".review-swiper-container");

  if (containers.length === 0) {
    // nothing to do now
    return;
  }

  containers.forEach((container) => {
    // If Swiper already attached via instance property, skip
    if (container.swiper) return;

    const isFour = container.id.includes("four");

    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      simulateTouch: true,
      allowTouchMove: true,
      cssMode: true,
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: false,
          pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
          }
        },
        1080: {
          slidesPerView: "auto",
          spaceBetween: isFour ? 20 : 24,
          navigation: {
            nextEl: container.querySelector(".swiper-button-next-hcp-arrow"),
            prevEl: container.querySelector(".swiper-button-prev-hcp-arrow"),
          },
          pagination: false
        },
         1501: {
          slidesPerView: 4,
          spaceBetween: isFour ? 20 : 24,
          navigation: {
            nextEl: container.querySelector(".swiper-button-next-hcp-arrow"),
            prevEl: container.querySelector(".swiper-button-prev-hcp-arrow"),
          },
          pagination:false
        },
      }
    });
  });
}

// ========================
// Debounce helper
// ========================
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// ========================
// Initialize everything
// ========================
function initializeAll() {
  initializeVideoHandlers();
  initializeSwipers();
}

// DOM ready init (small delay to let dynamic sections render)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(initializeAll, 100));
} else {
  setTimeout(initializeAll, 100);
}

// Reinitialize when DOM changes (Shopify dynamic sections)
const debouncedInitialize = debounce(initializeAll, 250);
const observer = new MutationObserver(function(mutations) {
  for (const mutation of mutations) {
    if (mutation.addedNodes && mutation.addedNodes.length) {
      debouncedInitialize();
      break;
    }
  }
});
observer.observe(document.body, { childList: true, subtree: true });

// Reinitialize swipers on resize
window.addEventListener('resize', debounce(initializeSwipers, 150));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comp-reviews-slider"] && !Shopify.designMode) return;
  try {
      
function debounce(fn, delay) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), delay);
  };
}

// Wrap your whole script logic in a function
const initVideoAndSwiper = debounce(() => {
  const allVideos = document.querySelectorAll(".hcp-card-video-slidev2");
  const allPlayButtons = document.querySelectorAll(".play-button-slidev2");
  const allThumbnails = document.querySelectorAll(".video-thumbnail-slidev2");

  allVideos.forEach((video, index) => {
    const playButton = allPlayButtons[index];
    const thumbnail = allThumbnails[index];

    function togglePlay() {
      // Pause ALL other videos (even in other sections)
      allVideos.forEach((otherVideo, otherIndex) => {
        if (otherIndex !== index && !otherVideo.paused) {
          otherVideo.pause();
          allPlayButtons[otherIndex].classList.remove("hidden");
          allThumbnails[otherIndex].classList.remove("hidden");
        }
      });

      if (video.paused) {
        video.play();
        playButton.classList.add("hidden");
        thumbnail.classList.add("hidden");
      } else {
        video.pause();
        playButton.classList.remove("hidden");
      }
    }

    playButton?.addEventListener("click", togglePlay);
    video?.addEventListener("click", togglePlay);

    video?.addEventListener("ended", () => {
      playButton.classList.remove("hidden");
      thumbnail.classList.remove("hidden");
    });
  });

  // ========================
  // Swiper initialization (per section)
  // ========================
  document.querySelectorAll(".review-swiper-container").forEach((container) => {
    const isFour = container.id.includes("four");

    new Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      simulateTouch: true,
      allowTouchMove: true,
      mousewheel: true,
      breakpoints: {
        0: { // Mobile & tablet
          slidesPerView: 'auto',
          spaceBetween: 0,
          navigation: false,
          pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
          }
        },
        1080: { // Desktop
          slidesPerView: 3,
          spaceBetween: isFour ? 20 : 24,
          navigation: {
            nextEl: container.querySelector(".swiper-button-next-hcp-arrow"),
            prevEl: container.querySelector(".swiper-button-prev-hcp-arrow"),
          },
          pagination: false
        }
      }
    });
  });
}, 500); // 👈 Adjust delay (in ms) here

// Run after window load or DOM ready
window.addEventListener("load", initVideoAndSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // onScroll() {
    //   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //   if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    //   if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    //     this.header.classList.add('scrolled-past-header');
    //     if (this.preventHide) return;
    //     requestAnimationFrame(this.hide.bind(this));
    //   } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
    //     this.header.classList.add('scrolled-past-header');
    //     if (!this.preventReveal) {
    //       requestAnimationFrame(this.reveal.bind(this));
    //     } else {
    //       window.clearTimeout(this.isScrolling);

    //       this.isScrolling = setTimeout(() => {
    //         this.preventReveal = false;
    //       }, 66);

    //       requestAnimationFrame(this.hide.bind(this));
    //     }
    //   } else if (scrollTop <= this.headerBounds.top) {
    //     this.header.classList.remove('scrolled-past-header');
    //     requestAnimationFrame(this.reset.bind(this));
    //   }

    //   this.currentScrollTop = scrollTop;
    // }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Dynamic scrollOffset based on screen width
      let scrollOffset = 120; // default for larger screens
      if (window.innerWidth <= 1079) {
        scrollOffset = 20;
      }

      // if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > scrollOffset
      ) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));

      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > scrollOffset
      ) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop <= scrollOffset) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiw-image-text-v1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('section.hiw-image-text-v1').forEach(function(imgTxtSection) {
    var imgTxtOverlay = imgTxtSection.querySelector('.pop-up-modal-overlay');
    if (!imgTxtOverlay) return;

    var imgTxtPopups = imgTxtSection.querySelectorAll('.popup-wrapper');

    imgTxtPopups.forEach(function(imgTxtPopupWrapper) {
      var imgTxtTrigger = imgTxtPopupWrapper.querySelector('.popup-title--wrapper');
      var imgTxtModal = imgTxtPopupWrapper.nextElementSibling; // modal is right after wrapper
      var imgTxtClose = imgTxtModal?.querySelector('.popup-close');

      if (!imgTxtTrigger || !imgTxtModal || !imgTxtClose) return;

      // Open popup
      imgTxtTrigger.addEventListener('click', function(e) {
        e.preventDefault();

        // Close all other modals in this section
        imgTxtSection.querySelectorAll('.popup-modal.active').forEach(function(m) {
          m.classList.remove('active');
        });
        imgTxtOverlay.classList.remove('active');

        // Open clicked modal
        imgTxtModal.classList.add('active');
        imgTxtOverlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });

      // Close popup via close button
      imgTxtClose.addEventListener('click', function(e) {
        e.preventDefault();
        imgTxtOverlay.classList.remove('active');
        document.body.style.overflow = '';

        // Wait for transition to finish before removing .active
        imgTxtModal.style.transform = 'translateX(100%)';
        imgTxtModal.style.opacity = '0';

        imgTxtModal.addEventListener('transitionend', function handler() {
          imgTxtModal.classList.remove('active');
          // reset inline styles
          imgTxtModal.style.transform = '';
          imgTxtModal.style.opacity = '';
          imgTxtModal.removeEventListener('transitionend', handler);
        });
      });
    });

    // Close popup via overlay click
    imgTxtOverlay.addEventListener('click', function() {
      imgTxtSection.querySelectorAll('.popup-modal.active').forEach(function(m) {
        document.body.style.overflow = '';
        m.style.transform = 'translateX(100%)';
        m.style.opacity = '0';

        m.addEventListener('transitionend', function handler() {
          m.classList.remove('active');
          m.style.transform = '';
          m.style.opacity = '';
          m.removeEventListener('transitionend', handler);
        });
      });
      imgTxtOverlay.classList.remove('active');
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiw-slider"] && !Shopify.designMode) return;
  try {
    
  class HiwSlider {
    constructor() {
      this.slider = null;
      this.init();
    }

    init() {
      document.addEventListener('DOMContentLoaded', () => {
        this.setupSlider();
      });
    }

    setupSlider() {
      const sliderElement = document.getElementById('slider--wrapper');
      
      if (!sliderElement || typeof $.fn.slick !== 'function') {
        return;
      }

      this.slider = $(sliderElement).slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '10',
        focusOnSelect: false,
        draggable: true,
        swipeToSlide: true,
        swipe: true,
        touchMove: true,
        prevArrow: $('.slider-arrows-hiw .slick-prev'),
        nextArrow: $('.slider-arrows-hiw .slick-next'),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 4,
              centerMode: false,
              centerPadding: '0',
            }
          },
          {
            breakpoint: 1080,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              centerMode: false,
              arrows: true,
              centerPadding: '0px',
            }
          }
        ],
        // Accessibility improvements
        accessibility: true,
        adaptiveHeight: true,
        // Performance optimizations
        cssEase: 'ease',
        easing: 'linear',
        useCSS: true
      });

      // Add event listeners for better accessibility
      this.setupAccessibility();
    }

    setupAccessibility() {
      if (!this.slider) return;

      // Handle keyboard navigation
      this.slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        const slides = slick.$slides;
        slides[currentSlide].setAttribute('aria-hidden', 'true');
        slides[nextSlide].setAttribute('aria-hidden', 'false');
      });

      // Handle focus management
      $('.slick-prev, .slick-next').on('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          $(e.currentTarget).click();
        }
      });
    }

    // Method to destroy the slider if needed
    destroy() {
      if (this.slider) {
        this.slider.slick('unslick');
        this.slider = null;
      }
    }
  }

  // Initialize the slider
  const hiwSlider = new HiwSlider();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works-banner"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const blocks = document.querySelectorAll(".hiw-banner .block-content--wrapper");
  
  if (blocks.length > 0) {
    // Open the first one by default
    blocks[0].classList.add("active");
  }

  blocks.forEach(block => {
    const title = block.querySelector(".title--toggle");
    const content = block.querySelector(".content");
    
    if (title && content) {
      title.addEventListener("click", function() {
        const isActive = block.classList.contains("active");

        // Close all blocks first
        blocks.forEach(b => b.classList.remove("active"));

        // If the clicked block was not active, activate it
        if (!isActive) {
          block.classList.add("active");
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-reviews-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  $('#pp-reviews__video-wrap').slick({
    centerMode: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0',
    focusOnSelect: false,
    prevArrow: "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='36' height='37' viewBox='0 0 36 37' fill='none'><path d='M12 0.760742H24C30.3513 0.760742 35.5 5.90947 35.5 12.2607V24.2607C35.5 30.612 30.3513 35.7607 24 35.7607H12C5.64873 35.7607 0.5 30.612 0.5 24.2607V12.2607C0.5 5.90947 5.64873 0.760742 12 0.760742Z' fill='#E1EBEB'/><path d='M12 0.760742H24C30.3513 0.760742 35.5 5.90947 35.5 12.2607V24.2607C35.5 30.612 30.3513 35.7607 24 35.7607H12C5.64873 35.7607 0.5 30.612 0.5 24.2607V12.2607C0.5 5.90947 5.64873 0.760742 12 0.760742Z' stroke='#EDF2F2'/><path d='M10.1737 18.9472L16.3612 25.1347C16.4903 25.2637 16.6652 25.3362 16.8477 25.3362C17.0301 25.3362 17.2051 25.2637 17.3341 25.1347C17.4631 25.0057 17.5355 24.8308 17.5355 24.6483C17.5355 24.4659 17.4631 24.2909 17.3341 24.1619L12.3196 19.1483H25.7852C25.9675 19.1483 26.1424 19.0759 26.2713 18.947C26.4002 18.818 26.4727 18.6432 26.4727 18.4608C26.4727 18.2785 26.4002 18.1036 26.2713 17.9747C26.1424 17.8458 25.9675 17.7733 25.7852 17.7733H12.3196L17.3341 12.7597C17.4631 12.6307 17.5355 12.4558 17.5355 12.2733C17.5355 12.0909 17.4631 11.9159 17.3341 11.7869C17.2051 11.6579 17.0301 11.5854 16.8477 11.5854C16.6652 11.5854 16.4903 11.6579 16.3612 11.7869L10.1737 17.9744C10.1098 18.0383 10.0591 18.1141 10.0245 18.1976C9.98992 18.281 9.97211 18.3705 9.97211 18.4608C9.97211 18.5512 9.98992 18.6406 10.0245 18.7241C10.0591 18.8076 10.1098 18.8834 10.1737 18.9472Z' fill='#194141'/></svg></button>",
    nextArrow: "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='36' height='37' viewBox='0 0 36 37' fill='none'><path d='M24 0.760742H12C5.64873 0.760742 0.5 5.90947 0.5 12.2607V24.2607C0.5 30.612 5.64873 35.7607 12 35.7607H24C30.3513 35.7607 35.5 30.612 35.5 24.2607V12.2607C35.5 5.90947 30.3513 0.760742 24 0.760742Z' fill='#E1EBEB'/><path d='M24 0.760742H12C5.64873 0.760742 0.5 5.90947 0.5 12.2607V24.2607C0.5 30.612 5.64873 35.7607 12 35.7607H24C30.3513 35.7607 35.5 30.612 35.5 24.2607V12.2607C35.5 5.90947 30.3513 0.760742 24 0.760742Z' stroke='#EDF2F2'/><path d='M25.8263 18.9472L19.6388 25.1347C19.5097 25.2637 19.3348 25.3362 19.1523 25.3362C18.9699 25.3362 18.7949 25.2637 18.6659 25.1347C18.5369 25.0057 18.4645 24.8308 18.4645 24.6483C18.4645 24.4659 18.5369 24.2909 18.6659 24.1619L23.6804 19.1483H10.2148C10.0325 19.1483 9.85764 19.0759 9.72871 18.947C9.59978 18.818 9.52734 18.6432 9.52734 18.4608C9.52734 18.2785 9.59978 18.1036 9.72871 17.9747C9.85764 17.8458 10.0325 17.7733 10.2148 17.7733H23.6804L18.6659 12.7597C18.5369 12.6307 18.4645 12.4558 18.4645 12.2733C18.4645 12.0909 18.5369 11.9159 18.6659 11.7869C18.7949 11.6579 18.9699 11.5854 19.1523 11.5854C19.3348 11.5854 19.5097 11.6579 19.6388 11.7869L25.8263 17.9744C25.8902 18.0383 25.9409 18.1141 25.9755 18.1976C26.0101 18.281 26.0279 18.3705 26.0279 18.4608C26.0279 18.5512 26.0101 18.6406 25.9755 18.7241C25.9409 18.8076 25.8902 18.8834 25.8263 18.9472Z' fill='#194141'/></svg></button>",
    responsive: [
      
      {
        breakpoint: 1079,
        settings: {
          centerMode: false,
          centerPadding: 'auto',
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows:true,
          variableWidth: false
        }
      },
      {
        breakpoint: 9999,
        settings: "unslick"
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-reviews-v3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Initialize the slider

  $('#video-wrap-v3').slick({
    dots: false,
    infinite: true, // This is what creates cloned slides
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    prevArrow: "<button type='button' aria-label='Previous Slide' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='48' height='49' viewBox='0 0 48 49' fill='none'><rect y='0.916016' width='48' height='48' rx='12' fill='#EDF2F2'/><path d='M32 24.916H16M16 24.916L22 30.916M16 24.916L22 18.916' stroke='#C7C7C7' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow: "<button type='button' aria-label='Next Slide' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='48' height='49' viewBox='0 0 48 49' fill='none'><rect y='0.916016' width='48' height='48' rx='12' fill='#6E908F'/><path d='M16 24.916H32M32 24.916L26 18.916M32 24.916L26 30.916' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    responsive: [    
      {
        breakpoint: 1080,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          infinite: true, // This maintains clones in mobile view too
          arrows: false // Changed from nextArrow/prevArrow: false to arrows: false
        }
      }
    ]
  });
  $('#video-wrap-v3 .slick-next').on('click', function () {
    $('#video-wrap-v3 .slick-prev svg').replaceWith("<svg xmlns='http://www.w3.org/2000/svg' width='48' height='49' viewBox='0 0 48 49' fill='none'><rect y='0.916016' width='48' height='48' rx='12' fill='#6E908F'></rect><path d='M32 24.916H16M16 24.916L22 30.916M16 24.916L22 18.916' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'></path></svg>");
  });
  // This won't work as expected because clones are regenerated during navigation
  $('#video-wrap-v3').on('init', function() {
    $('.slick-cloned').remove();
  });
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-lp-v2"] && !Shopify.designMode) return;
  try {
    
  function initAccordions() {
      const accordionHeaders = document.querySelectorAll('.xxx');

      if (accordionHeaders.length === 0) {
          // If no accordions found, try again after a short delay
          setTimeout(initAccordions, 100);
          return;
      }

      // First ensure all accordions are closed
      document.querySelectorAll('.imgtxt-accordion__content').forEach(content => {
          content.classList.remove('imgtxt-accordion__content--open');
      });
      document.querySelectorAll('.imgtxt-accordion__icon').forEach(icon => {
          icon.classList.remove('imgtxt-accordion__icon--open');
      });

      accordionHeaders.forEach(header => {
          // Skip if already initialized
          if (header.dataset.accordionInitialized) return;
          header.dataset.accordionInitialized = 'true';

          header.addEventListener('click', function() {
              const accordionItem = this.closest('.imgtxt-accordion__item');
              const content = accordionItem.querySelector('.imgtxt-accordion__content');
              const icon = this.querySelector('.imgtxt-accordion__icon');
              const isStyle2 = accordionItem.querySelector('.accordion-icon') !== null;

              // Toggle this item
              const isOpening = !content.classList.contains('imgtxt-accordion__content--open');

              // Close all others first if opening this one
              if (isOpening) {
                  document.querySelectorAll('.imgtxt-accordion__content--open').forEach(openContent => {
                      if (openContent !== content) {
                          openContent.classList.remove('imgtxt-accordion__content--open');
                          const openIcon = openContent.closest('.imgtxt-accordion__item').querySelector('.imgtxt-accordion__icon');
                          if (openIcon) {
                              openIcon.classList.remove('imgtxt-accordion__icon--open');
                              // For style 2, rotate back the plus sign
                              if (openIcon.querySelector('.accordion-icon')) {
                                  openIcon.querySelector('.accordion-icon-plus').style.transform = 'rotate(0deg)';
                              }
                          }
                      }
                  });
              }

              // Toggle this item
              content.classList.toggle('imgtxt-accordion__content--open');

              if (icon) {
                  icon.classList.toggle('imgtxt-accordion__icon--open');

                  // For style 2, rotate the plus sign to make it an X
                  if (isStyle2) {
                      const plusSign = icon.querySelector('.accordion-icon-plus');
                      if (plusSign) {
                          if (content.classList.contains('imgtxt-accordion__content--open')) {
                              plusSign.style.transform = 'rotate(45deg)';
                          } else {
                              plusSign.style.transform = 'rotate(0deg)';
                          }
                      }
                  }
              }
          });
      });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
      initAccordions();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-lp"] && !Shopify.designMode) return;
  try {
    
  function initAccordions() {
      const accordionHeaders = document.querySelectorAll('.imgtxt-accordion__header');

      if (accordionHeaders.length === 0) {
          // If no accordions found, try again after a short delay
          setTimeout(initAccordions, 100);
          return;
      }

      // First ensure all accordions are closed
      document.querySelectorAll('.imgtxt-accordion__content').forEach(content => {
          content.classList.remove('imgtxt-accordion__content--open');
      });
      document.querySelectorAll('.imgtxt-accordion__icon').forEach(icon => {
          icon.classList.remove('imgtxt-accordion__icon--open');
      });

      accordionHeaders.forEach(header => {
          // Skip if already initialized
          if (header.dataset.accordionInitialized) return;
          header.dataset.accordionInitialized = 'true';

          header.addEventListener('click', function() {
              const accordionItem = this.closest('.imgtxt-accordion__item');
              const content = accordionItem.querySelector('.imgtxt-accordion__content');
              const icon = this.querySelector('.imgtxt-accordion__icon');
              const isStyle2 = accordionItem.querySelector('.accordion-icon') !== null;

              // Toggle this item
              const isOpening = !content.classList.contains('imgtxt-accordion__content--open');

              // Close all others first if opening this one
              if (isOpening) {
                  document.querySelectorAll('.imgtxt-accordion__content--open').forEach(openContent => {
                      if (openContent !== content) {
                          openContent.classList.remove('imgtxt-accordion__content--open');
                          const openIcon = openContent.closest('.imgtxt-accordion__item').querySelector('.imgtxt-accordion__icon');
                          if (openIcon) {
                              openIcon.classList.remove('imgtxt-accordion__icon--open');
                              // For style 2, rotate back the plus sign
                              if (openIcon.querySelector('.accordion-icon')) {
                                  openIcon.querySelector('.accordion-icon-plus').style.transform = 'rotate(0deg)';
                              }
                          }
                      }
                  });
              }

              // Toggle this item
              content.classList.toggle('imgtxt-accordion__content--open');

              if (icon) {
                  icon.classList.toggle('imgtxt-accordion__icon--open');

                  // For style 2, rotate the plus sign to make it an X
                  if (isStyle2) {
                      const plusSign = icon.querySelector('.accordion-icon-plus');
                      if (plusSign) {
                          if (content.classList.contains('imgtxt-accordion__content--open')) {
                              plusSign.style.transform = 'rotate(45deg)';
                          } else {
                              plusSign.style.transform = 'rotate(0deg)';
                          }
                      }
                  }
              }
          });
      });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAccordions);
  } else {
      initAccordions();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
   $('#logo-text-inner').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow:"<button type='button' aria-label='Previous Slide' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='8' height='15' viewBox='0 0 8 15' fill='none'> <path d='M7 13.5L1 7.5L7 1.5' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/> </svg></button>",
      nextArrow:"<button type='button' aria-label='Previous Slide' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='8' height='15' viewBox='0 0 8 15' fill='none'> <path d='M1 13.5L7 7.5L1 1.5' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/> </svg></button>",
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: 0,
            dots:true,
            infinite: true
          }
        },
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: 0,
            dots:true,
            infinite: true
          }
        }
   
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-section-navigation"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const onPageLinks = document.querySelectorAll(".on-page-link");
  const onPageSections = document.querySelectorAll(".lp-image-text-v1, .center-video--section, .vagus-nerve-benefits--section"); // Added .vnb--wrapper
  const scrollContainer = document.querySelector('[id*="__lp_section_navigation_hidden"] .on-page-nav_container');
  let onPageWindowWidth = window.innerWidth;

  onPageLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const onPageTargetId = link.getAttribute("href").substring(1);
      const onPageTargetSection = document.getElementById(onPageTargetId);

      if (onPageTargetSection) {
        const targetPosition = calculateScrollPosition(onPageTargetSection);
        window.scrollTo({
          top: targetPosition,
          behavior: "smooth",
        });

        updateActiveLink(link);
        scrollToLinkInContainer(link, 400);
        
        // Add active class to target section and remove from others
        onPageSections.forEach(section => {
          section.classList.remove("active");
        });
        onPageTargetSection.classList.add("active");
      }
    });
  });

  window.addEventListener("scroll", () => {
    let onPageCurrentSection = "";

    onPageSections.forEach(section => {
      const offset = onPageWindowWidth >= 1080 ? 150 : 182; // Adjust offsets for desktop and mobile
      const onPageSectionTop = section.offsetTop - offset;
      const onPageSectionHeight = section.offsetHeight;

      if (
        window.scrollY >= onPageSectionTop - 50 &&
        window.scrollY < onPageSectionTop + onPageSectionHeight - 50
      ) {
        onPageCurrentSection = section.getAttribute("id");
        // Add active class to current section
        section.classList.add("active");
      } else {
        // Remove active class from other sections
        section.classList.remove("active");
      }
    });

    onPageLinks.forEach(link => {
      link.classList.remove("active");
      if (link.getAttribute("href").substring(1) === onPageCurrentSection) {
        link.classList.add("active");
      }
    });

    updateScrollContainerPosition(onPageCurrentSection);
  });

  function calculateScrollPosition(targetSection) {
    const OPsectionTop = targetSection.getBoundingClientRect().top + window.scrollY;
    if (onPageWindowWidth >= 1080) {
      // Desktop: Scroll to the top of the section
      return OPsectionTop - 150; // Offset for fixed header
    } else {
      // Mobile: Scroll to the middle of the section
      const sectionHeight = targetSection.offsetHeight;
      const viewportHeight = window.innerHeight;
      return OPsectionTop - (viewportHeight / 2 - sectionHeight / 2) + 155;
    }
  }

  function updateActiveLink(activeLink) {
    onPageLinks.forEach(link => link.classList.remove("active"));
    activeLink.classList.add("active");
  }

  function smoothScrollTo(target, duration) {
    const start = scrollContainer.scrollLeft;
    const end = target;
    const startTime = performance.now();

    function scroll() {
      const currentTime = performance.now();
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      scrollContainer.scrollLeft = start + (end - start) * progress;

      if (progress < 1) {
        requestAnimationFrame(scroll);
      }
    }

    requestAnimationFrame(scroll);
  }

  function updateScrollContainerPosition(currentSectionId) {
    const currentLink = document.querySelector(`a[href="#${currentSectionId}"]`);
    if (currentLink) {
      const linkLeft = currentLink.getBoundingClientRect().left + scrollContainer.scrollLeft;
      smoothScrollTo(linkLeft - scrollContainer.offsetLeft, 100);
    }
  }

  function scrollToLinkInContainer(link, duration) {
    const targetSectionId = link.getAttribute("href").substring(1);
    const targetLink = document.querySelector(`a[href="#${targetSectionId}"]`);
    if (targetLink) {
      const linkLeft = targetLink.getBoundingClientRect().left + scrollContainer.scrollLeft;
      smoothScrollTo(linkLeft - scrollContainer.offsetLeft, duration);
    }
  }
});

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-reviews-infinite-scroll-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  // ===== Debounce helper =====
  function debounce(fn, delay = 300) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  let topSwiper = null;
  let bottomSwiper = null;
  const BREAKPOINT = 1080;

  // Prevent native image dragging
  function preventNativeImageDrag(selector) {
    document.querySelectorAll(selector).forEach((img) => {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', (e) => e.preventDefault());
      img.style.userSelect = 'none';
      img.style.webkitUserDrag = 'none';
    });
  }

  // Destroy both Swipers if active
  function destroySwipers() {
    if (topSwiper) { try { topSwiper.destroy(true, true); } catch (e) {} topSwiper = null; }
    if (bottomSwiper) { try { bottomSwiper.destroy(true, true); } catch (e) {} bottomSwiper = null; }
  }

  // ===== Desktop marquee setup =====
  function initDesktopSwipers() {
    destroySwipers();

    const topEl = document.querySelector('#reviews-marquee__swiper-top');
    const bottomEl = document.querySelector('#reviews-marquee__swiper-bottom');
    if (!topEl || !bottomEl) return;

    topEl.style.display = '';
    bottomEl.style.display = '';

    preventNativeImageDrag('#reviews-marquee__swiper-top img, #reviews-marquee__swiper-bottom img');

    const baseMarqueeConfig = {
      slidesPerView: 'auto',
      spaceBetween: 24,
      loop: true,
      loopedSlides: 20,
      allowTouchMove: false,
      freeMode: true,
      freeModeMomentum: false,
      centeredSlides: false,
      speed: 30000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      on: {
        loopFix(swiper) {
          swiper.setTranslate(swiper.getTranslate() % swiper.width);
        },
        afterInit(swiper) {
          swiper.wrapperEl.style.transitionTimingFunction = 'linear';
        },
      },
    };

    topSwiper = new Swiper('#reviews-marquee__swiper-top', {
      ...baseMarqueeConfig,
    });

    bottomSwiper = new Swiper('#reviews-marquee__swiper-bottom', {
      ...baseMarqueeConfig,
      autoplay: {
        ...baseMarqueeConfig.autoplay,
        reverseDirection: true,
      },
    });

    [topSwiper, bottomSwiper].forEach(swiper => {
      swiper.wrapperEl.style.transitionTimingFunction = 'linear';
    });
  }

  // ===== Mobile swiper setup =====
  function initMobileSwiper() {
    destroySwipers();

    const topEl = document.querySelector('#reviews-marquee__swiper-top');
    const bottomEl = document.querySelector('#reviews-marquee__swiper-bottom');
    if (!topEl || !bottomEl) return;

    bottomEl.style.display = 'none';
    topEl.style.display = '';

    preventNativeImageDrag('#reviews-marquee__swiper-top img');

    topSwiper = new Swiper('#reviews-marquee__swiper-top', {
      slidesPerView: 'auto',
      spaceBetween: 16,
      loop: true,
      loopedSlides: 3,
      centeredSlides: false,
      speed: 500, // Smooth transition speed
      autoplay: {
        delay: 3000, // Changed to 3 seconds for proper autoplay
        disableOnInteraction: false,
      },
      pagination: {
        el: '#reviews-marquee__swiper-top .swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      on: {
        init(swiper) {
          swiper.loopFix();
        },
        slideChangeTransitionStart(swiper) {
          // Fix loop before transition starts
          if (swiper.params.loop) {
            const realSlides = swiper.slides.length - (swiper.loopedSlides * 2);
            if (swiper.activeIndex >= realSlides + swiper.loopedSlides || swiper.activeIndex < swiper.loopedSlides) {
              swiper.loopFix();
            }
          }
        },
        transitionEnd(swiper) {
          // Ensure autoplay continues smoothly
          if (swiper.autoplay.running) {
            swiper.autoplay.resume();
          }
        }
      },
    });

    // Force initial alignment and start autoplay
    setTimeout(() => {
      if (topSwiper) {
        topSwiper.update();
        topSwiper.loopFix();
        // Ensure autoplay starts
        topSwiper.autoplay.start();
      }
    }, 100);
  }

  // ===== Handle initialization =====
  function handleInit() {
    if (window.innerWidth >= BREAKPOINT) {
      initDesktopSwipers();
    } else {
      initMobileSwiper();
    }
  }

  // ===== Debounced init on DOM load =====
  const debouncedInit = debounce(handleInit, 500);
  debouncedInit();

  // ===== Debounced resize listener =====
  let lastMode = window.innerWidth >= BREAKPOINT ? 'desktop' : 'mobile';
  window.addEventListener('resize', debounce(function () {
    const mode = window.innerWidth >= BREAKPOINT ? 'desktop' : 'mobile';
    if (mode !== lastMode) {
      lastMode = mode;
      handleInit();
    }
  }, 300));

  // Prevent drag on initial load
  preventNativeImageDrag('#reviews-marquee__swiper-top img, #reviews-marquee__swiper-bottom img');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-reviews-infinite-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const commonConfig = {
    slidesPerView: 'auto', 
    centeredSlides: true,
    spaceBetween: 20,
    loop: true,
    resistanceRatio: 0,
    watchSlidesProgress: true,
    autoplay: {
      delay: 1, // Minimal delay
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
      waitForTransition: false
    },
    speed: 50000, // Still high but more consistent
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      0: {
        slidesPerView: 'auto',
        spaceBetween: 10
      }
    }
  };

  let initialized = false;
  let topSwiper, bottomSwiper;

  function initSwipers() {
    if (initialized) return;
    initialized = true;
    
    topSwiper = new Swiper('#reviews-marquee__swiper-top', commonConfig);
    
    bottomSwiper = new Swiper('#reviews-marquee__swiper-bottom', {
      ...commonConfig,
      autoplay: {
        ...commonConfig.autoplay,
        reverseDirection: true
      }
    });
  }

  setTimeout(initSwipers, 100);

  // Debounced resize handler
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (topSwiper) topSwiper.update();
      if (bottomSwiper) bottomSwiper.update();
    }, 100);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospecting-brands-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  $('#brands-slick').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '100px',
    focusOnSelect: false,
    prevArrow: "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='52' viewBox='0 0 52 52' fill='none'><path d='M0 10C0 4.47715 4.47715 0 10 0L42 0C47.5228 0 52 4.47715 52 10L52 42C52 47.5228 47.5228 52 42 52L10 52C4.47715 52 0 47.5228 0 42L0 10Z' fill='#124143' fill-opacity='0.25'/><path d='M18 26L34 26M18 26L24 20M18 26L24 32' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow: "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='52' viewBox='0 0 52 52' fill='none'><path d='M0 10C0 4.47715 4.47715 0 10 0L42 0C47.5228 0 52 4.47715 52 10L52 42C52 47.5228 47.5228 52 42 52L10 52C4.47715 52 0 47.5228 0 42L0 10Z' fill='#124143' fill-opacity='0.25'/><path d='M34 26H18M34 26L28 32M34 26L28 20' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: '80px'
        }
      },
      {
        breakpoint: 1080,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 749,
        settings: {
          centerMode: true,
          centerPadding: '0px',  // Changed to 0px for single slide
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prospecting-v2-slider-card"] && !Shopify.designMode) return;
  try {
    
function initExpertRecsSlick(root) {
  if (!window.jQuery || !(window.jQuery.fn && typeof window.jQuery.fn.slick === 'function')) return;

  var $root = root ? $(root) : $(document);
  var $slider = $root.find('#expert-recs-slick');
  if (!$slider.length) return;

  var isMobile = window.matchMedia('(max-width: 1079px)').matches;

 
  if (!isMobile) {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    return;
  }

 
  if ($slider.hasClass('slick-initialized')) return;

  
  var $dots = $root.find('#expert-recs-dots');
  if (!$dots.length) {
    $dots = $slider.closest('.expert-recs').find('#expert-recs-dots');
  }

  $slider.slick({
    dots: true,
    appendDots: $dots,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: '0px',
    focusOnSelect: false,
  variableWidth: true,
  });
}

document.addEventListener('DOMContentLoaded', function() {
 
  initExpertRecsSlick(document);

  
  var t;
  window.addEventListener('resize', function() {
    window.clearTimeout(t);
    t = window.setTimeout(function() {
      initExpertRecsSlick(document);
    }, 150);
  }, { passive: true });
});

document.addEventListener('shopify:section:load', function(e) {

  initExpertRecsSlick(e.target);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resilience-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  $('#resilience--column').slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '0px',
    focusOnSelect: false,

    responsive: [
      {
        breakpoint: 1080,
        settings: "unslick"
      },
      {
        breakpoint: 1079,
        settings: {
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 2,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 749,
        settings: {
          centerMode: false,
          variableWidth: true,
          centerPadding: '0px',
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-infinite-scroll-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  requestAnimationFrame(() => {
    const reviewSwiperTop = new Swiper('#reviews-marquee__swiper-top', {
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      speed: 26000,
      breakpoints: {
        768: { slidesPerView: 3 },
        0: { slidesPerView: 1 }
      },
      on: {
        init: function () {
          this.autoplay.start(); // manually trigger autoplay in case
        }
      }
    });

    const reviewSwiperBottom = new Swiper('#reviews-marquee__swiper-bottom', {
      slidesPerView: 3,
      centeredSlides: true,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
        reverseDirection: true,
        pauseOnMouseEnter: false,
      },
      speed: 22000,
      breakpoints: {
        768: { slidesPerView: 3 },
        0: { slidesPerView: 1 }
      },
      on: {
        init: function () {
          this.autoplay.start();
        }
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-infinite-scroll-v3"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const BREAKPOINT = 1080;
  let topSwiper = null;

  function debounce(fn, delay = 300) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function preventDrag(selector) {
    document.querySelectorAll(selector).forEach((img) => {
      img.setAttribute("draggable", "false");
      img.addEventListener("dragstart", (e) => e.preventDefault());
      img.style.userSelect = "none";
      img.style.webkitUserDrag = "none";
    });
  }

  function destroySwipers() {
    if (topSwiper) {
      try { topSwiper.destroy(true, true); } catch (e) {}
      topSwiper = null;
    }
  }

  // ===== DESKTOP MARQUEE =====
  function initDesktopMarquee() {
    destroySwipers();

    const topWrapper = document.querySelector("#reviews-marquee__swiper-top .swiper-wrapper");
    const bottomWrapper = document.querySelector("#reviews-marquee__swiper-bottom .swiper-wrapper");
    const topEl = document.querySelector("#reviews-marquee__swiper-top");
    const bottomEl = document.querySelector("#reviews-marquee__swiper-bottom");
    
    if (!topWrapper || !bottomWrapper) return;

    topEl.style.display = "";
    bottomEl.style.display = "";

    // Reset wrappers
    [topWrapper, bottomWrapper].forEach((wrapper) => {
      wrapper.style.animation = "none";
      wrapper.style.transform = "translateX(0)";
      wrapper.style.display = "flex";
      wrapper.style.width = "max-content";
    });

    // Force reflow
    void topWrapper.offsetWidth;
    void bottomWrapper.offsetWidth;

    // Duplicate content for seamless looping
    function duplicateContent(wrapper) {
      const children = wrapper.children;
      const originalCount = children.length;
      
      // Clone all existing slides and append them
      for (let i = 0; i < originalCount; i++) {
        const clone = children[i].cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        wrapper.appendChild(clone);
      }
    }

    // Only duplicate if not already duplicated
    if (!topWrapper.querySelector('[data-clone]')) {
      duplicateContent(topWrapper);
    }
    if (!bottomWrapper.querySelector('[data-clone]')) {
      duplicateContent(bottomWrapper);
    }

    // Calculate total width of original content (without clones)
    function getOriginalWidth(wrapper) {
      let totalWidth = 0;
      const children = wrapper.children;
      
      for (let i = 0; i < children.length; i++) {
        if (!children[i].hasAttribute('data-clone')) {
          const slide = children[i];
          const slideWidth = slide.offsetWidth;
          const style = window.getComputedStyle(slide);
          const marginRight = parseFloat(style.marginRight) || 0;
          totalWidth += slideWidth + marginRight;
        }
      }
      return totalWidth;
    }

    const topOriginalWidth = getOriginalWidth(topWrapper);
    const bottomOriginalWidth = getOriginalWidth(bottomWrapper);

    // Set animation
    const duration = 90; // seconds for one loop - adjust as needed

    topWrapper.style.animation = `marqueeLeft ${duration}s linear infinite`;
    bottomWrapper.style.animation = `marqueeRight ${duration}s linear infinite`;

    preventDrag("#reviews-marquee__swiper-top img, #reviews-marquee__swiper-bottom img");
  }

  // ===== MOBILE SWIPER =====
  function initMobileSwiper() {
    destroySwipers();

    const topEl = document.querySelector("#reviews-marquee__swiper-top");
    const bottomEl = document.querySelector("#reviews-marquee__swiper-bottom");
    if (!topEl || !bottomEl) return;

    topEl.style.display = "";
    bottomEl.style.display = "none";

    // Remove clones and reset animations for mobile
    const topWrapper = document.querySelector("#reviews-marquee__swiper-top .swiper-wrapper");
    const bottomWrapper = document.querySelector("#reviews-marquee__swiper-bottom .swiper-wrapper");
    
    if (topWrapper) {
      const clones = topWrapper.querySelectorAll('[data-clone]');
      clones.forEach(clone => clone.remove());
      topWrapper.style.animation = "none";
      topWrapper.style.transform = "translateX(0)";
      topWrapper.style.width = "";
      topWrapper.style.display = "";
    }

    if (bottomWrapper) {
      const clones = bottomWrapper.querySelectorAll('[data-clone]');
      clones.forEach(clone => clone.remove());
      bottomWrapper.style.animation = "none";
      bottomWrapper.style.transform = "translateX(0)";
      bottomWrapper.style.width = "";
      bottomWrapper.style.display = "";
    }

    preventDrag("#reviews-marquee__swiper-top img");

    topSwiper = new Swiper("#reviews-marquee__swiper-top", {
      slidesPerView: "auto",
      spaceBetween: 16,
      loop: true,
      speed: 500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: "#reviews-marquee__swiper-top .swiper-pagination",
        clickable: true,
      },
    });
  }

  // ===== INIT HANDLER =====
  function handleInit() {
    if (window.innerWidth >= BREAKPOINT) {
      initDesktopMarquee();
    } else {
      initMobileSwiper();
    }
  }

  const debouncedInit = debounce(handleInit, 300);
  
  // Initialize on load
  setTimeout(handleInit, 100);

  // ===== RESIZE SWITCH =====
  let lastMode = window.innerWidth >= BREAKPOINT ? "desktop" : "mobile";
  window.addEventListener(
    "resize",
    debounce(function () {
      const mode = window.innerWidth >= BREAKPOINT ? "desktop" : "mobile";
      if (mode !== lastMode) {
        lastMode = mode;
        handleInit();
      }
    }, 300)
  );

  preventDrag("#reviews-marquee__swiper-top img, #reviews-marquee__swiper-bottom img");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-infinite-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const BREAKPOINT = 1080;
  let topSwiper = null;

  function debounce(fn, delay = 300) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function preventDrag(selector) {
    document.querySelectorAll(selector).forEach((img) => {
      img.setAttribute("draggable", "false");
      img.addEventListener("dragstart", (e) => e.preventDefault());
      img.style.userSelect = "none";
      img.style.webkitUserDrag = "none";
    });
  }

  function destroySwipers() {
    if (topSwiper) {
      try { topSwiper.destroy(true, true); } catch (e) {}
      topSwiper = null;
    }
  }

  // ===== DESKTOP MARQUEE =====
  function initDesktopMarquee() {
    destroySwipers();

    const topWrapper = document.querySelector("#reviews-marquee__swiper-top .swiper-wrapper");
    const bottomWrapper = document.querySelector("#reviews-marquee__swiper-bottom .swiper-wrapper");
    const topEl = document.querySelector("#reviews-marquee__swiper-top");
    const bottomEl = document.querySelector("#reviews-marquee__swiper-bottom");
    
    if (!topWrapper || !bottomWrapper) return;

    topEl.style.display = "";
    bottomEl.style.display = "";

    // Reset wrappers
    [topWrapper, bottomWrapper].forEach((wrapper) => {
      wrapper.style.animation = "none";
      wrapper.style.transform = "translateX(0)";
      wrapper.style.display = "flex";
      wrapper.style.width = "max-content";
    });

    // Force reflow
    void topWrapper.offsetWidth;
    void bottomWrapper.offsetWidth;

    // Duplicate content for seamless looping
    function duplicateContent(wrapper) {
      const children = wrapper.children;
      const originalCount = children.length;
      
      // Clone all existing slides and append them
      for (let i = 0; i < originalCount; i++) {
        const clone = children[i].cloneNode(true);
        clone.setAttribute('data-clone', 'true');
        wrapper.appendChild(clone);
      }
    }

    // Only duplicate if not already duplicated
    if (!topWrapper.querySelector('[data-clone]')) {
      duplicateContent(topWrapper);
    }
    if (!bottomWrapper.querySelector('[data-clone]')) {
      duplicateContent(bottomWrapper);
    }

    // Calculate total width of original content (without clones)
    function getOriginalWidth(wrapper) {
      let totalWidth = 0;
      const children = wrapper.children;
      
      for (let i = 0; i < children.length; i++) {
        if (!children[i].hasAttribute('data-clone')) {
          const slide = children[i];
          const slideWidth = slide.offsetWidth;
          const style = window.getComputedStyle(slide);
          const marginRight = parseFloat(style.marginRight) || 0;
          totalWidth += slideWidth + marginRight;
        }
      }
      return totalWidth;
    }

    const topOriginalWidth = getOriginalWidth(topWrapper);
    const bottomOriginalWidth = getOriginalWidth(bottomWrapper);

    // Set animation
    const duration = 90; // seconds for one loop - adjust as needed

    topWrapper.style.animation = `marqueeLeft ${duration}s linear infinite`;
    bottomWrapper.style.animation = `marqueeRight ${duration}s linear infinite`;

    preventDrag("#reviews-marquee__swiper-top img, #reviews-marquee__swiper-bottom img");
  }

  // ===== MOBILE SWIPER =====
  function initMobileSwiper() {
    destroySwipers();

    const topEl = document.querySelector("#reviews-marquee__swiper-top");
    const bottomEl = document.querySelector("#reviews-marquee__swiper-bottom");
    if (!topEl || !bottomEl) return;

    topEl.style.display = "";
    bottomEl.style.display = "none";

    // Remove clones and reset animations for mobile
    const topWrapper = document.querySelector("#reviews-marquee__swiper-top .swiper-wrapper");
    const bottomWrapper = document.querySelector("#reviews-marquee__swiper-bottom .swiper-wrapper");
    
    if (topWrapper) {
      const clones = topWrapper.querySelectorAll('[data-clone]');
      clones.forEach(clone => clone.remove());
      topWrapper.style.animation = "none";
      topWrapper.style.transform = "translateX(0)";
      topWrapper.style.width = "";
      topWrapper.style.display = "";
    }

    if (bottomWrapper) {
      const clones = bottomWrapper.querySelectorAll('[data-clone]');
      clones.forEach(clone => clone.remove());
      bottomWrapper.style.animation = "none";
      bottomWrapper.style.transform = "translateX(0)";
      bottomWrapper.style.width = "";
      bottomWrapper.style.display = "";
    }

    preventDrag("#reviews-marquee__swiper-top img");

    topSwiper = new Swiper("#reviews-marquee__swiper-top", {
      slidesPerView: "auto",
      spaceBetween: 16,
      loop: true,
      speed: 500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
        el: "#reviews-marquee__swiper-top .swiper-pagination",
        clickable: true,
      },
    });
  }

  // ===== INIT HANDLER =====
  function handleInit() {
    if (window.innerWidth >= BREAKPOINT) {
      initDesktopMarquee();
    } else {
      initMobileSwiper();
    }
  }

  const debouncedInit = debounce(handleInit, 300);
  
  // Initialize on load
  setTimeout(handleInit, 100);

  // ===== RESIZE SWITCH =====
  let lastMode = window.innerWidth >= BREAKPOINT ? "desktop" : "mobile";
  window.addEventListener(
    "resize",
    debounce(function () {
      const mode = window.innerWidth >= BREAKPOINT ? "desktop" : "mobile";
      if (mode !== lastMode) {
        lastMode = mode;
        handleInit();
      }
    }, 300)
  );

  preventDrag("#reviews-marquee__swiper-top img, #reviews-marquee__swiper-bottom img");
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider-slick"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('.v2-button-container').forEach(element => element.remove());
document.querySelector('.homepage-reviews-stats').remove();

const videosSlidesV2 = document.querySelectorAll(".hcp-card-video-slidev2");
const playButtonsSlidesV2 = document.querySelectorAll(".play-button-slidev2");
const thumbnailsSlidesV2 = document.querySelectorAll(".video-thumbnail-slidev2");

videosSlidesV2.forEach((videoSlideV2, index) => {
  const playButtonSlideV2 = playButtonsSlidesV2[index]; // Get corresponding play button
  const thumbnailSlidesV2 = thumbnailsSlidesV2[index]; // Get corresponding fallback image button

  function togglePlaySlideV2() {

    // Pause all other videos
    videosSlidesV2.forEach((otherVideo, otherIndex) => {
      if (otherIndex !== index && !otherVideo.paused) {
        otherVideo.pause();
        playButtonsSlidesV2[otherIndex].classList.remove("hidden");
      }
    });

    if (videoSlideV2.paused) {
      videoSlideV2.play();
      playButtonSlideV2.classList.add("hidden"); // Hide play button when playing
      thumbnailSlidesV2.classList.add("hidden"); 
    } else {
      videoSlideV2.pause();
      playButtonSlideV2.classList.remove("hidden"); // Show play button when paused
      // thumbnailSlidesV2.classList.remove("hidden"); 
    }
  }

  // Click on play button to toggle play/pause
  playButtonSlideV2.addEventListener("click", togglePlaySlideV2);

  // Click anywhere on the video to toggle play/pause
  videoSlideV2.addEventListener("click", togglePlaySlideV2);

  // Ensure play button appears when video ends
  videoSlideV2.addEventListener("ended", () => {
    playButtonSlideV2.classList.remove("hidden");
  });
});


var reviewsSliderSix = new Swiper('#reviews-slider__slider-six', {
    slidesPerView: 1,      
    spaceBetween: 0,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        1080: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      }
  });

  var reviewsSliderFour = new Swiper('#reviews-slider__slider-four', {
    slidesPerView: 1,      
    spaceBetween: 0,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        1080: {
          slidesPerView: 2,
          spaceBetween: 20,
        }
      }
  });



// document.addEventListener('DOMContentLoaded', () => {
//     const sliders = document.querySelectorAll('.reviews-slider');

//     sliders.forEach(slider => {
//         const slidesContainer = slider.querySelector('.reviews-slider__slides');
//         const slides = slider.querySelectorAll('.reviews-slider__slide');
//         const prevBtn = slider.querySelector('.reviews-slider__arrow--prev');
//         const nextBtn = slider.querySelector('.reviews-slider__arrow--next');
//         const dotsContainer = slider.querySelector('.new-reviews-slider-dots');
        
//         let slidesPerView = window.innerWidth >= 1080 ? 2 : 1;
//         let currentIndex = 0;
//         let dots = [];
//         let isAnimating = false;

//         // Clone first and last slides for infinite effect
//         const firstSlide = slides[0].cloneNode(true);
//         const lastSlide = slides[slides.length - 1].cloneNode(true);
//         slidesContainer.prepend(lastSlide);
//         slidesContainer.append(firstSlide);

//         // Initialize slider position (start at the first "real" slide)
//         const slideWidth = slides[0].offsetWidth + parseFloat(getComputedStyle(slides[0]).marginRight);
//         slidesContainer.scrollLeft = slideWidth * slidesPerView; // Start at the first original slide

//         // Initialize dots (ignore cloned slides)
//         const initDots = () => {
//             dotsContainer.innerHTML = '';
//             const dotCount = slides.length; // Original slides only
            
//             for (let i = 0; i < dotCount; i++) {
//                 const dot = document.createElement('div');
//                 dot.classList.add('reviews-slider__dot');
//                 dot.addEventListener('click', () => goToSlide(i));
//                 dotsContainer.appendChild(dot);
//                 dots.push(dot);
//             }
//             updateDots();
//         };

//         // Update active dot (based on "real" index)
//         const updateDots = () => {
//             dots.forEach((dot, i) => {
//                 dot.classList.toggle('active', i === currentIndex);
//             });
//         };

//         // Go to a specific slide (handles infinite loop)
//         const goToSlide = (index) => {
//             if (isAnimating) return;
//             isAnimating = true;

//             const totalSlides = slides.length;
//             const scrollPos = (index + 1) * slideWidth * slidesPerView; // +1 to account for the prepended clone

//             slidesContainer.scrollTo({
//                 left: scrollPos,
//                 behavior: 'smooth'
//             });

//             currentIndex = (index + totalSlides) % totalSlides; // Ensure index is within bounds
//             updateDots();

//             // Reset animation flag after scroll completes
//             setTimeout(() => {
//                 isAnimating = false;
//             }, 500);
//         };

//         // Handle scroll events to detect when we need to loop
//         const handleScroll = () => {
//             const scrollPos = slidesContainer.scrollLeft;
//             const maxScroll = slidesContainer.scrollWidth - slidesContainer.clientWidth;
//             const slideWidth = slides[0].offsetWidth + parseFloat(getComputedStyle(slides[0]).marginRight);

//             // If scrolled to the beginning (cloned last slide), jump to the end
//             if (scrollPos < slideWidth * slidesPerView) {
//                 slidesContainer.scrollLeft = maxScroll - slideWidth * slidesPerView;
//             }
//             // If scrolled to the end (cloned first slide), jump to the start
//             else if (scrollPos >= maxScroll - slideWidth * slidesPerView) {
//                 slidesContainer.scrollLeft = slideWidth * slidesPerView;
//             }

//             // Update currentIndex based on scroll position (ignoring clones)
//             const newIndex = Math.round((scrollPos - slideWidth * slidesPerView) / (slideWidth * slidesPerView));
//             currentIndex = (newIndex + slides.length) % slides.length;
//             updateDots();
//         };

//         // Navigation arrows (infinite)
//         nextBtn.addEventListener('click', () => {
//             goToSlide(currentIndex + 1);
//         });

//         prevBtn.addEventListener('click', () => {
//             goToSlide(currentIndex - 1);
//         });

//         // Handle resize (reinitialize dots and reset position)
//         const handleResize = () => {
//             const newSlidesPerView = window.innerWidth >= 1080 ? 2 : 1;
//             if (newSlidesPerView !== slidesPerView) {
//                 slidesPerView = newSlidesPerView;
//                 initDots();
//                 slidesContainer.scrollLeft = slideWidth * slidesPerView; // Reset to first "real" slide
//             }
//         };

//         // Initialize
//         initDots();
//         slidesContainer.addEventListener('scroll', handleScroll);
//         window.addEventListener('resize', handleResize);
//     });
// });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('.v2-button-container').forEach(element => element.remove());
document.querySelector('.homepage-reviews-stats').remove();

const videosSlidesV2 = document.querySelectorAll(".hcp-card-video-slidev2");
const playButtonsSlidesV2 = document.querySelectorAll(".play-button-slidev2");
const thumbnailsSlidesV2 = document.querySelectorAll(".video-thumbnail-slidev2");

videosSlidesV2.forEach((videoSlideV2, index) => {
  const playButtonSlideV2 = playButtonsSlidesV2[index]; // Get corresponding play button
  const thumbnailSlidesV2 = thumbnailsSlidesV2[index]; // Get corresponding fallback image button

  function togglePlaySlideV2() {

    // Pause all other videos
    videosSlidesV2.forEach((otherVideo, otherIndex) => {
      if (otherIndex !== index && !otherVideo.paused) {
        otherVideo.pause();
        playButtonsSlidesV2[otherIndex].classList.remove("hidden");
      }
    });

    if (videoSlideV2.paused) {
      videoSlideV2.play();
      playButtonSlideV2.classList.add("hidden"); // Hide play button when playing
      thumbnailSlidesV2.classList.add("hidden"); 
    } else {
      videoSlideV2.pause();
      playButtonSlideV2.classList.remove("hidden"); // Show play button when paused
      // thumbnailSlidesV2.classList.remove("hidden"); 
    }
  }

  // Click on play button to toggle play/pause
  playButtonSlideV2.addEventListener("click", togglePlaySlideV2);

  // Click anywhere on the video to toggle play/pause
  videoSlideV2.addEventListener("click", togglePlaySlideV2);

  // Ensure play button appears when video ends
  videoSlideV2.addEventListener("ended", () => {
    playButtonSlideV2.classList.remove("hidden");
  });
});


  function initReviewsSwiper() {
  if (typeof Swiper !== "undefined") {
    

var reviewsSliderSix = new Swiper('#reviews-slider__slider-six', {
    slidesPerView: 1,      
    spaceBetween: 0,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-hcp-arrow',
      prevEl: '.swiper-button-prev-hcp-arrow',
    },
    breakpoints: {
        1080: {
          slidesPerView: 4,
          spaceBetween: 20,
        }
      }
  });

  var reviewsSliderFour = new Swiper('#reviews-slider__slider-four', {
    slidesPerView: 1,      
    spaceBetween: 0,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-hcp-arrow',
      prevEl: '.swiper-button-prev-hcp-arrow',
    },
    breakpoints: {
        1080: {
          slidesPerView: 2,
          spaceBetween: 20,
        }
      }
  });
  } else {
    // Retry after a short delay if Swiper isn’t ready yet
    setTimeout(initReviewsSwiper, 100);
  }
}

document.addEventListener("DOMContentLoaded", initReviewsSwiper);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    $('#testimonials-slick').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3, 
  slidesToScroll: 1,
  centerMode: false,   
  centerPadding: '10', 
  focusOnSelect: false,
  draggable: true,
  swipeToSlide: true,
  swipe: true,
  touchMove: true,
  prevArrow:
    "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='66' height='56' viewBox='0 0 66 56' fill='none'><rect x='-0.388889' y='0.388889' width='64.5556' height='55.2222' rx='12.0556' transform='matrix(-1 0 0 1 65.2222 0)' fill='#E1EBEB'/><rect x='-0.388889' y='0.388889' width='64.5556' height='55.2222' rx='12.0556' transform='matrix(-1 0 0 1 65.2222 0)' stroke='#C3D8DB' stroke-width='0.777778'/><path d='M27.203 27.8776H39.6475M27.203 27.8776L31.8697 23.2109M27.203 27.8776L31.8697 32.5443' stroke='#416768' stroke-width='1.55556' stroke-linecap='square'/></button>",
  nextArrow:
    "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='66' height='56' viewBox='0 0 66 56' fill='none'><rect x='0.388889' y='0.388889' width='64.5556' height='55.2222' rx='12.0556' fill='#E1EBEB'/><rect x='0.388889' y='0.388889' width='64.5556' height='55.2222' rx='12.0556' stroke='#C3D8DB' stroke-width='0.777778'/><path d='M38.797 27.8776H26.3525M38.797 27.8776L34.1303 23.2109M38.797 27.8776L34.1303 32.5443' stroke='#416768' stroke-width='1.55556' stroke-linecap='square'/></button>",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 2,
        centerMode: false,
        centerPadding: '0',
      }, 
    },
    {
      breakpoint: 1080,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        centerMode: false,
        arrows:false,
        centerPadding: '0px',
      },
    }
    // {
    //   breakpoint: 749,
    //   settings: {
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     dots: false,
    //     centerMode: false,
    //     centerPadding: '0px',
    //   },
    // },
  ],
});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  $('#testimonials-slick').slick({
    centerMode: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '100px',
    focusOnSelect: false,
    prevArrow: "<button type='button' class='slick-prev'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='52' viewBox='0 0 52 52' fill='none'><path d='M0 10C0 4.47715 4.47715 0 10 0L42 0C47.5228 0 52 4.47715 52 10L52 42C52 47.5228 47.5228 52 42 52L10 52C4.47715 52 0 47.5228 0 42L0 10Z' fill='#124143' fill-opacity='0.25'/><path d='M18 26L34 26M18 26L24 20M18 26L24 32' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    nextArrow: "<button type='button' class='slick-next'><svg xmlns='http://www.w3.org/2000/svg' width='52' height='52' viewBox='0 0 52 52' fill='none'><path d='M0 10C0 4.47715 4.47715 0 10 0L42 0C47.5228 0 52 4.47715 52 10L52 42C52 47.5228 47.5228 52 42 52L10 52C4.47715 52 0 47.5228 0 42L0 10Z' fill='#124143' fill-opacity='0.25'/><path d='M34 26H18M34 26L28 32M34 26L28 20' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg></button>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          centerPadding: '80px'
        }
      },
      {
        breakpoint: 1080,
        settings: {
          centerMode: true,
          centerPadding: '60px',
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 749,
        settings: {
          centerMode: true,
          centerPadding: '0px',
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();
})();
